import Button from "@app/components/move2Library/Button/Button"
import { faRepeat } from "@fortawesome/free-solid-svg-icons/faRepeat"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export default function ({ onRetry, loading, show }) {
	if (!show) {
		return null
	}

	return (
		<div className="flex-1 text-center flex flex-center">
			<div>
				<div>
					<span>It seems that an error has occurred.</span>
				</div>
				<Button style="secondary" className="mt-3" isLoading={loading} onClick={onRetry}>
					{!loading && <FontAwesomeIcon icon={faRepeat} className="mr-2" />} <span>Retry</span>
				</Button>
			</div>
		</div>
	)
}
